import { render, staticRenderFns } from "./SdsTableSection14.vue?vue&type=template&id=eb13a0a2"
import script from "./SdsTableSection14.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection14.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports